import React, { useEffect } from "react";
import { useMediaQuery } from "../../../hooks";
import { Partner } from "../../api";
import { PartnerConfig } from "../../partner_config";
import { Spacer } from "../../spacer";
import { TemplatePartnerPortalIndexV2 } from "./template_partner_portal_index_v2";
import styles from "./portal_manage_membership_page.module.css";
import { ManageMembershipPaymentMethod } from "../components/manage_membership_payment_method";
import { PortalCancelMembership } from "../components/portal_cancel_membership";
import { PortalBackButton } from "../components/portal_back_button";
import { ManageMembershipDetails } from "../components/manage_membership_details";
import { PortalMembershipChargesTable } from "../components/portal_membership_charges_table";
import { useParams } from "react-router-dom";
import { PortalPathParams } from "../hooks/use_portal_history";
import { useSubscriptionDetailsQuery } from "../hooks/use_subscription_details_query";
import { useMembershipManagementAnalytics } from "../hooks/use_membership_management_analytics";

interface PortalManageMembershipPageProps {
  partnerConfig: PartnerConfig;
  partner: Partner;
}

export function PortalManageMembershipPage({
  partner,
  partnerConfig,
}: PortalManageMembershipPageProps) {
  const { device } = useMediaQuery();
  const { subscriptionId } = useParams<PortalPathParams>();
  const analyticEvent = useMembershipManagementAnalytics();

  const { data: subscriptionDetailsData } = useSubscriptionDetailsQuery(
    partner.id,
    subscriptionId
  );

  const isCancelled = subscriptionDetailsData?.status === "canceled";

  useEffect(() => {
    analyticEvent("Manage Membership View");
  }, [analyticEvent]);

  return (
    <TemplatePartnerPortalIndexV2
      partner={partner}
      partnerConfig={partnerConfig}
    >
      <div>
        <Spacer size={device === "mobile" ? 38 : 45} />
        <PortalBackButton>Back to Your Membership</PortalBackButton>
        <Spacer size={device === "mobile" ? 38 : 45} />
        <div className={styles.pageTitleWrapper}>
          {isCancelled && <div className={styles.cancelledChip}>CANCELLED</div>}
          <div className={styles.title}>
            {isCancelled ? "Membership Details" : "Manage Membership"}
          </div>
        </div>

        <Spacer size={device === "mobile" ? 32 : 40} />
        <div className={styles.membershipDetailsWrapper}>
          <div className={styles.card}>
            <ManageMembershipDetails partnerId={partner.id} />
          </div>

          {!isCancelled && (
            <>
              <Spacer
                size={device === "mobile" ? 24 : 32}
                direction={device === "mobile" ? "vertical" : "horizontal"}
              />
              <div className={styles.card}>
                <ManageMembershipPaymentMethod partner={partner} />
              </div>
            </>
          )}
        </div>

        <Spacer size={device === "mobile" ? 24 : 40} />
        <div className={styles.card}>
          <PortalMembershipChargesTable
            partnerId={partner.id}
            partnerName={partner.name}
          />
        </div>

        <Spacer size={device === "mobile" ? 24 : 40} />
        <div className={device === "mobile" ? styles.centerBtn : ""}>
          <PortalCancelMembership partnerId={partner.id} />
        </div>
      </div>
    </TemplatePartnerPortalIndexV2>
  );
}
